let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6dERU"), load("gd4qs"), load("7gF8f"), load("7nRXR")]).then(() => parcelRequire('04hGF'));